var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 4,
    fill: "#384654"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1782 19C24.1782 19.3488 23.8954 19.6316 23.5467 19.6316H19.6316V23.5466C19.6316 23.8954 19.3488 24.1782 19 24.1782C18.6512 24.1782 18.3684 23.8954 18.3684 23.5466V19.6316H14.4534C14.1046 19.6316 13.8218 19.3488 13.8218 19C13.8218 18.6512 14.1046 18.3684 14.4534 18.3684H18.3684V14.4533C18.3684 14.1046 18.6512 13.8218 19 13.8218C19.3488 13.8218 19.6316 14.1046 19.6316 14.4533V18.3684H23.5467C23.8954 18.3684 24.1782 18.6512 24.1782 19ZM31 19C31 22.2053 29.7518 25.2188 27.4853 27.4853C25.2188 29.7518 22.2053 31 19 31C15.7947 31 12.7812 29.7518 10.5147 27.4853C8.2482 25.2188 7 22.2053 7 19C7 15.7947 8.2482 12.7812 10.5147 10.5147C12.7812 8.2482 15.7947 7 19 7C22.2053 7 25.2188 8.2482 27.4853 10.5147C29.7518 12.7812 31 15.7947 31 19ZM29.7368 19C29.7368 13.0797 24.9203 8.26316 19 8.26316C13.0797 8.26316 8.26316 13.0797 8.26316 19C8.26316 24.9203 13.0797 29.7368 19 29.7368C24.9203 29.7368 29.7368 24.9203 29.7368 19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.b268956ea1a8524d50b48e8b6c0e83af.svg";
export { ForwardRef as ReactComponent };